import classcat from "classcat";
import React from "react";

import css from "./MaskedItem.module.css";

type Props = {
  isChecked: boolean;
};

const MaskedItem = ({ isChecked }: Props) => (
  <div className={classcat([css.container, { [css.isChecked]: isChecked }])} />
);

export default MaskedItem;
